// Add your custom JS here.

// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min';

// Vreemde import, geen idee waarom dit wel werkt, zie link hieronder
// https://stackoverflow.com/questions/64113404/bootstrap-5-referenceerror-bootstrap-is-not-defined
//import * as bootstrap from 'bootstrap';


//import javascript files
import './theme/util/jquery.matchHeight-min.js';
import './theme/match-height.js';

import './theme/util/imagesloaded.pkgd.min.js';
import './theme/isotope.js';
import './theme/isotopefunction.js';

import './theme/sliders.js';
import './theme/header.js';
import './theme/layout-accordion.js';
import './theme/countup.js';
import './theme/banner-popup.js';
import './theme/scroll-to-top.js';
import './theme/header_searchform.js';

import './theme/swiperslides.js';


// JQ start here
(function($){

  //dom ready
  $(window).ready(function(){
    //remove preloader after loaded
    $('.preloader').fadeOut('200');

    //only for navigation_hotel
    if($('body').hasClass('navigation_hotel')){
      //subnavigatie hoogte top bepalen 
      var heightofnav = $('header .container .row').outerHeight(false);
      $('header .subnavigation').css('top',heightofnav);

      //subnavigation event trigger
      $('.subnavigation').hide();
        
      $('.nav-primary .menu-item-has-children').hover(function(){
        var navitem = $(this).find('a.nav-link').data('idofpage');
        $('.subnavigation').each(function(){
          if( $(this).data('idofpagetoshow') == navitem ){
            $('.subnavigation[data-idofpagetoshow="'+navitem+'"]').addClass('expanded').stop().slideDown(250);
          }else{
            $(this).hide();
          }
        });
      });

      $('header').mouseleave(function() {
        //$(this).slideUp(10);
        $('.subnavigation.expanded').removeClass('expanded').slideUp(250);
      });

    }

  })

  // $("body[data-header='navigation_onepager-01'] h2").each(function (index) {
  //   $(this).addClass('hal-' + $(this).css('textAlign'));
  // });
}(jQuery));